import { cva } from "class-variance-authority";
import { cn } from "cn";
import type { FC } from "react";
import React from "react";

import { bindArgs } from "@core/foundation/function";

import type { VariantProps } from "@react/ui-primitives/lib";

import type { LogEntry, LogEntryId } from "@apis/calorie-grid/models";

import { CATEGORY_META } from "../../../bootstrap/category.ts";

const variants = cva("", {
  defaultVariants: { active: false },
  variants: {
    active: {
      false: "border-transparent bg-muted",
      true: "border-foreground/40 bg-foreground/5",
    },
  },
});

interface LogEntryChipProps extends VariantProps<typeof variants> {
  readonly logEntry: LogEntry;
  readonly onSelect: (id: LogEntryId) => void;
}

export const LogEntryChip: FC<LogEntryChipProps> = ({
  active,
  logEntry,
  onSelect,
}) => {
  const categoryColor = CATEGORY_META[logEntry.category].color;

  return (
    <button
      className={cn(
        "flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1",
        variants({ active }),
      )}
      onClick={bindArgs(onSelect, logEntry.id)}
      type="button"
    >
      <span
        className="size-2 shrink-0 rounded-full"
        style={{ backgroundColor: categoryColor }}
      />
      <span className="max-w-[12ch] truncate text-xs font-medium">
        {logEntry.name}
      </span>
    </button>
  );
};
